import { getAll, put, deleteItem, clear } from './utils/transactionHelpers'

export const savePendingEvent = async eventData => {
    try {
        const item = { id: Date.now(), ...eventData }
        await put('pendingEvents', item)
        return item.id
    } catch (error) {
        console.error('Failed to save event:', error)
        throw error
    }
}

export const getPendingEvents = async () => {
    try {
        return await getAll('pendingEvents')
    } catch (error) {
        console.error('Error fetching events:', error)
        return []
    }
}

export const deletePendingEvent = async eventId => {
    try {
        await deleteItem('pendingEvents', eventId)
    } catch (error) {
        console.error('Error deleting event:', error)
        throw error
    }
}

export const deleteAllPendingEvents = async () => {
    try {
        await clear('pendingEvents')
        console.log('All pending events deleted successfully')
    } catch (error) {
        console.error('Error deleting all pending events:', error)
        throw error
    }
}
